import { createContext, useContext } from 'react';

export interface MarzipanoController {
  zoomIn: () => void;
  zoomOut: () => void;
  pan: (direction: 'up' | 'down' | 'left' | 'right') => void;
  toggleAutorotate: () => void;
  resetView: () => void;
  isAutorotateEnabled: () => boolean;
}

export const MarzipanoControllerContext = createContext<MarzipanoController | null>(null);

export function useMarzipanoController() {
  return useContext(MarzipanoControllerContext);
}
